/* eslint-disable react/prop-types */

const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({
  headerInfo,
  rows,
  openingBalance,
  totalArising,
  closingBalance,
  cumulativeQuarter,
  cumulativeYear,
  cumulativeFromStart,
}) => {
  // 1. Render các dòng phát sinh trong kỳ (Items)
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="text-center">${row.recordingDate || ""}</td>
        <td class="text-center">${row.documentNumber || ""}</td>
        <td class="text-center">${row.documentDate || ""}</td>
        <td>${row.description || ""}</td>
        <td class="text-center">${row.correspondingAccount || ""}</td>
        <td class="text-right">${fmt(row.totalAmount)}</td>
        <td class="text-right">${fmt(row.constructionAmount)}</td>
        <td class="text-right">${fmt(row.equipmentTotal)}</td>
        <td class="text-right">${fmt(row.equipmentRequireInstallation)}</td>
        <td class="text-right">${fmt(row.equipmentNoInstallation)}</td>
        <td class="text-right">${fmt(row.toolsAmount)}</td>
        <td class="text-right">${fmt(row.otherAmount)}</td>
        <td>${row.note || ""}</td>
      </tr>
    `
    )
    .join("");

  // Helper để render các dòng tổng hợp (tránh lặp code HTML)
  const renderSummaryRow = (label, obj, isBold = true) => `
    <tr class="${isBold ? "row-highlight" : ""}">
      <td colspan="3"></td>
      <td ${!isBold ? 'class="bold"' : ""}>${label}</td>
      <td></td>
      <td class="text-right">${fmt(obj?.totalAmount)}</td>
      <td class="text-right">${fmt(obj?.constructionAmount)}</td>
      <td class="text-right">${fmt(obj?.equipmentTotal)}</td>
      <td class="text-right">${fmt(obj?.equipmentRequireInstallation)}</td>
      <td class="text-right">${fmt(obj?.equipmentNoInstallation)}</td>
      <td class="text-right">${fmt(obj?.toolsAmount)}</td>
      <td class="text-right">${fmt(obj?.otherAmount)}</td>
      <td></td>
    </tr>
  `;

  // 2. Render toàn bộ template HTML
  return `
    <html>
      <head>
        <title>In Sổ Chi Phí Đầu Tư Xây Dựng</title>
        <style>
          @media print {
            @page { margin: 10mm; size: landscape; }
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 0;
            margin: 0;
            font-size: 11px; /* Cỡ chữ nhỏ hơn chút để vừa bảng ngang nhiều cột */
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 15px; }
          .title-box { text-align: center; margin: 15px 0; }
          .title-main { font-size: 16px; font-weight: bold; margin: 0; text-transform: uppercase; }
          
          .project-info { width: 80%; margin: 0 auto 15px auto; line-height: 1.6; }
          .flex-row { display: flex; align-items: center; margin-bottom: 4px; }
          
          table { width: 100%; border-collapse: collapse; font-size: 11px; }
          th, td { border: 1px solid #000; padding: 4px; }
          th { text-align: center; font-weight: bold; vertical-align: middle; }
          
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .text-left { text-align: left; }
          .bold { font-weight: bold; }
          .italic { font-style: italic; }
          
          .row-highlight td { font-weight: bold; background-color: #fafafa !important; }
          
          .footer-info { margin-top: 15px; line-height: 1.6; font-size: 12px; }
          .signature-section { display: flex; justify-content: space-between; margin-top: 20px; text-align: center; font-size: 12px; }
          .signature-box { width: 33%; }
          .signature-space { height: 60px; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 45%;">
            <div class="bold" style="margin-bottom: 5px;">Đơn vị: ${
              headerInfo.company || ".............................."
            }</div>
            <div class="bold">Địa chỉ: ${
              headerInfo.companyAddress || ".............................."
            }</div>
          </div>
          <div style="text-align: center; width: 55%;">
            <div class="bold">Mẫu số S52-DN</div>
            <div class="italic" style="margin-top: 4px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">SỔ CHI PHÍ ĐẦU TƯ XÂY DỰNG</h2>
          <div class="bold" style="margin-top: 5px;">Tài khoản 241 - Xây dựng cơ bản dở dang</div>
          <div class="bold italic" style="margin-top: 5px;">
            Năm: ${headerInfo.year || "..............."}
          </div>
        </div>

        <div class="project-info">
          <div class="bold flex-row">Dự án: <span style="font-weight: normal; margin-left: 5px;">${
            headerInfo.projectName ||
            "...................................................................................."
          }</span></div>
          <div class="bold flex-row">Công trình (HMCT): <span style="font-weight: normal; margin-left: 5px;">${
            headerInfo.constructionName ||
            "......................................................................"
          }</span></div>
          <div class="flex-row">
            <span class="bold">Khởi công...</span> <span style="margin: 0 15px;">${
              headerInfo.startDate || "...................................."
            }</span>
            <span class="bold">Hoàn thành...</span> <span style="margin-left: 10px;">${
              headerInfo.completionDate || "...................................."
            }</span>
          </div>
          <div class="bold flex-row">Tổng dự toán: <span style="font-weight: normal; margin-left: 5px;">${
            fmt(headerInfo.totalEstimatedBudget) ||
            "................................................."
          }</span></div>
        </div>

        <table>
          <thead>
            <tr>
              <th rowspan="3" style="width: 50px;">Ngày,<br/>tháng<br/>ghi sổ</th>
              <th colspan="2">Chứng từ</th>
              <th rowspan="3" style="width: 140px;">Diễn giải</th>
              <th rowspan="3" style="width: 40px;">Tài<br/>khoản<br/>đối ứng</th>
              <th rowspan="3" style="width: 70px;">Tổng<br/>số<br/>phát<br/>sinh</th>
              <th colspan="6">Nội dung chi phí</th>
              <th rowspan="3" style="width: 60px;">Ghi<br/>chú</th>
            </tr>
            <tr>
              <th rowspan="2" style="width: 50px;">Số<br/>hiệu</th>
              <th rowspan="2" style="width: 50px;">Ngày,<br/>tháng</th>
              <th rowspan="2" style="width: 70px;">Xây<br/>lắp</th>
              <th colspan="3">Thiết bị</th>
              <th rowspan="2" style="width: 70px;">Công<br/>cụ,<br/>dụng<br/>cụ</th>
              <th rowspan="2" style="width: 70px;">Khác</th>
            </tr>
            <tr>
              <th style="width: 70px;">Tổng<br/>số</th>
              <th style="width: 70px;">TB<br/>cần<br/>lắp</th>
              <th style="width: 70px;">TB<br/>không<br/>cần lắp</th>
            </tr>
            <tr style="background-color: #f0f0f0 !important;">
              <th>A</th>
              <th>B</th>
              <th>C</th>
              <th>D</th>
              <th>E</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
              <th>7</th>
              <th>F</th>
            </tr>
          </thead>
          <tbody>
            ${renderSummaryRow("1 - Số dư đầu kỳ", openingBalance, true)}

            <tr>
              <td colspan="3"></td>
              <td class="bold">2 - Số phát sinh trong kỳ</td>
              <td colspan="9"></td>
            </tr>

            ${rowsHtml}

            ${renderSummaryRow("Cộng số phát sinh", totalArising, true)}

            ${renderSummaryRow("3 - Số dư cuối kỳ", closingBalance, true)}

            ${renderSummaryRow("4 - Cộng lũy kế phát sinh quý", cumulativeQuarter, true)}

            ${renderSummaryRow("5 - Cộng lũy kế phát sinh từ đầu năm", cumulativeYear, true)}

            ${renderSummaryRow("6 - Cộng lũy kế phát sinh từ khởi công", cumulativeFromStart, true)}
          </tbody>
        </table>

        <div class="footer-info">
          <div>- Sổ này có <span class="bold">${
            headerInfo.totalPages || "....."
          }</span> trang, đánh số từ trang 01 đến trang...</div>
          <div>- Ngày mở sổ: ${headerInfo.openingDate || ".............................."}</div>
        </div>

        <div class="signature-section">
          <div class="signature-box">
            <div class="bold">Người ghi sổ</div>
            <div class="italic">(Ký, họ tên)</div>
            <div class="signature-space"></div>
            <div>${headerInfo.preparerName || ""}</div>
          </div>
          <div class="signature-box">
            <div class="bold">Kế toán trưởng</div>
            <div class="italic">(Ký, họ tên)</div>
            <div class="signature-space"></div>
            <div>${headerInfo.chiefAccountantName || ""}</div>
          </div>
          <div class="signature-box">
            <div class="italic" style="margin-bottom: 4px;">
              Ngày ${headerInfo.signingDay || "..."} tháng ${
    headerInfo.signingMonth || "..."
  } năm ${headerInfo.signingYear || "..."}
            </div>
            <div class="bold">Người đại diện theo pháp luật</div>
            <div class="italic">(Ký, họ tên, đóng dấu)</div>
            <div class="signature-space" style="height: 40px;"></div>
            <div>${headerInfo.legalRepresentativeName || ""}</div>
          </div>
        </div>

        <script>
          // Tự động gọi lệnh in khi cửa sổ load xong
          window.onload = function() {
            setTimeout(() => {
              window.print();
            }, 500);
          };
        </script>
      </body>
    </html>
  `;
};
